const localeFiles = require.context('../locales', true, /^\.\/(en|es)\/[^/]+\.json$/)

export const resources = localeFiles.keys().reduce((catalogs, path) => {
  const match = path.match(/^\.\/([^/]+)\/([^/]+)\.json$/)
  if (!match) return catalogs

  const [, language, namespace] = match
  catalogs[language] ||= {}
  catalogs[language][namespace] = localeFiles(path)
  return catalogs
}, {})

export const namespaces = Object.freeze(Object.keys(resources.en || {}))
